import { Breadcrumb } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

function CheckoutSteps({ step1, step2, step3, step4 }) {
  return (
    <>
      <Breadcrumb>
        Checkout&nbsp;|&nbsp;
        {step1 ? (
          <LinkContainer to="/checkout/billing-info">
            <Breadcrumb.Item>Billing info</Breadcrumb.Item>
          </LinkContainer>
        ) : (
          <LinkContainer to="/checkout/billing-info">
            <Breadcrumb.Item className="breadcrumb-disabled">
              Billing info
            </Breadcrumb.Item>
          </LinkContainer>
        )}
        {step2 ? (
          <LinkContainer to="/checkout/payment-method">
            <Breadcrumb.Item>Payment Method</Breadcrumb.Item>
          </LinkContainer>
        ) : (
          <LinkContainer to="/checkout/payment-method">
            <Breadcrumb.Item className="breadcrumb-disabled">
              Payment Method
            </Breadcrumb.Item>
          </LinkContainer>
        )}
        {step3 ? (
          <Breadcrumb.Item>Payment</Breadcrumb.Item>
        ) : (
          <LinkContainer to="/checkout/payment">
            <Breadcrumb.Item className="breadcrumb-disabled">
              Payment
            </Breadcrumb.Item>
          </LinkContainer>
        )}
        {step4 ? (
          <Breadcrumb.Item>Complete</Breadcrumb.Item>
        ) : (
          <LinkContainer to="/">
            <Breadcrumb.Item className="breadcrumb-disabled">
              Complete
            </Breadcrumb.Item>
          </LinkContainer>
        )}
      </Breadcrumb>
    </>
  );
}

export default CheckoutSteps;
